// extracted by mini-css-extract-plugin
export default {"nav":"InnerNavigation_nav__fPtWg","link":"InnerNavigation_link__t8HCQ","current":"InnerNavigation_current__yH6V9"};